export enum ReportTypeEnum {
  MY_REPORT = 'my-report',
  REPORT_MANAGEMENT = 'report-management'
}

export enum FilterVisibleEnum {
  REPORT_TYPE = 'reportType',
  DATE = 'date',
  CHANNEL = 'channel',
  CURRENCY = 'currency',
  INSTALL_STATUS = 'installStatus',
  PAYMENT_TYPE = 'paymentType',
  PAYMENT_STATUS = 'paymentStatus',
  DEVICE_TYPE = 'deviceType',
  INSTALL_TYPE = 'installType',
  REPORTING_PERIOD = 'reportingPeriod',
  TIME = 'time'
}

export enum RentalReportKeyEnum {
  TOTAL_RENTAL_BY_MONTH = 'TOTAL_RENTAL_BY_MONTH',
  TOTAL_RENTAL_BY_MONTH_AND_CHANNEL = 'TOTAL_RENTAL_BY_MONTH_AND_CHANNEL',
  RENTAL_PAYMENT = 'RENTAL_PAYMENT',
  RENTAL_ANALYSIS = 'RENTAL_ANALYSIS'
}

export enum ContractReportKeyEnum {
  CONTRACT_SUMMARY = 'CONTRACT_SUMMARY',
  NEW_CONTRACT = 'NEW_CONTRACT',
  OPTIMIZED_CONTRACT = 'OPTIMIZED_CONTRACT',
  DISCOUNT_CONTRACT = 'DISCOUNT_CONTRACT',
  LIQUIDATED_CONTRACT = 'LIQUIDATED_CONTRACT',
  RENEWED_CONTRACT = 'RENEWED_CONTRACT'
}

export enum DeviceReportKeyEnum {
  OPERATING_DEVICE_COUNT = 'OPERATING_DEVICE_COUNT',
  DEVICE_SUMMARY_BY_PERIOD = 'DEVICE_SUMMARY_BY_PERIOD',
  DEVICE_DETAIL_BY_LOCATION = 'DEVICE_DETAIL_BY_LOCATION',
  OPERATING_DEVICE_STATUS = 'OPERATING_DEVICE_STATUS'
}

export enum InstallStatusEnum {
  INSTALLATION = 'INSTALLATION',
  UNINSTALLATION = 'UNINSTALLATION',
  SIGNED = 'SIGNED',
  RECONCILED = 'RECONCILED'
}

export enum PaymentTypeEnum {
  BY_CONTRACT_NUMBER = 'by_contract_number',
  BY_DEVICE = 'by_device'
}

export enum PaymentStatusEnum {
  MUST_PAY = 'MUST_PAY',
  PAID = 'PAID'
}

export enum ChannelEnum {
  ALL = 'ALL',
}

export enum ContractExportCodeEnum {
	NEW = 'NEW',
	RENEW = 'RENEW',
	LIQUIDATION = 'LIQUIDATION',
	REDUCE = 'REDUCE',
	OPTIMIZATION = 'OPTIMIZATION',
	ALL_DAILY = 'ALL_DAILY',
	ALL_MONTHLY = 'ALL_MONTHLY'
}